var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShipping = function SvgShipping(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.993.942a1.089 1.089 0 0 0-.94.54L.15 4.748A1.089 1.089 0 0 0 0 5.296v13.061c0 1.19.987 2.177 2.177 2.177h15.238c1.19 0 2.177-.987 2.177-2.177V5.297c0-.194-.052-.383-.149-.55l-1.905-3.265a1.089 1.089 0 0 0-.94-.54H2.994Zm.625 2.177h12.356l1.269 2.177H2.349L3.62 3.12ZM2.177 7.473h15.238v10.884H2.177V7.473ZM6.53 9.65v2.177h6.53V9.65h-6.53Z",
    fill: "#2B2B2B"
  })));
};
export default SvgShipping;